import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import openPrintDialog from "@insite/client-framework/Common/Utilities/openPrintDialog";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { WIDGET_GROUP } from "@store/constants";
import { InvoicePaymentConfirmationPageContext } from "@store/Pages/InvoicePaymentConfirmationPage";
import { checkoutTitleWithLinksProps } from "@store/theme/common/props/checkout";
import pageTitleProps from "@store/theme/common/props/pageTitle";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const PageTitle = getWidgetComponent("Basic/PageTitle");

const mapStateToProps = (state: ApplicationState) => {
    return {
        pageTitle: getCurrentPage(state).fields.title,
    };
};

type Props = ReturnType<typeof mapStateToProps> & WidgetProps & HasHistory;

export interface InvoicePaymentConfirmationHeaderStyles {
    wrapper?: TypographyPresentationProps;
    innerWrapper?: TypographyPresentationProps;
    actionWrapper?: InjectableCss;
    heading?: TypographyPresentationProps;
    titleWrapper?: InjectableCss;
    wrapperItem?: InjectableCss;
    printLink?: LinkPresentationProps;
    backLink?: LinkPresentationProps;
    item?: InjectableCss;
}

const styles: InvoicePaymentConfirmationHeaderStyles = {
    wrapper: {
        ...pageTitleProps,
        forwardAs: "div",
    },
    innerWrapper: {
        variant: "body",
        forwardAs: "div",
        css: css`
            display: flex;
            flex-flow: row wrap;
            justify-content: space-between;
            align-items: center;
            margin: -0.5em 0 0 0;
        `,
    },
    actionWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    heading: {
        variant: "h2",
        css: css`
            margin-bottom: 0;
        `,
    },
    wrapperItem: checkoutTitleWithLinksProps.wrapperItem,
    printLink: checkoutTitleWithLinksProps.printLink,
    backLink: checkoutTitleWithLinksProps.backLink,
    item: checkoutTitleWithLinksProps.item,
};

const InvoicePaymentConfirmationHeader: React.FC<Props> = () => {
    return (
        <Typography {...styles.wrapper}>
            <Typography {...styles.innerWrapper}>
                <StyledWrapper {...styles.titleWrapper}>
                    <PageTitle />
                </StyledWrapper>
                <StyledWrapper {...styles.wrapperItem}>
                    <StyledWrapper {...styles.item}>
                        <Link {...styles.backLink} href="/MyAccount/Invoices">
                            {translate("Back")}
                        </Link>
                    </StyledWrapper>
                    <StyledWrapper {...styles.item}>
                        <Link {...styles.printLink} onClick={openPrintDialog}>
                            {translate("Print")}
                        </Link>
                    </StyledWrapper>
                </StyledWrapper>
            </Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(InvoicePaymentConfirmationHeader)),
    definition: {
        group: WIDGET_GROUP.invoicePayment as any,
        displayName: "Invoice Payment Header",
        icon: "PageTitle",
        allowedContexts: [InvoicePaymentConfirmationPageContext] as any[],
    },
};

export default widgetModule;
